export const headings = [
  { name: "GroupName" },
  { name: "Visibility" },
  { name: "Hotel" },
  { name: "Strength" },
  { name: "Action" },
];

export const formErrors = {
  hotelSelectError:
    "Please select a hotel if you are planing to add a privet group",
  addMembersError: "Please add at lease one user in the group",
  addNameError: "Please add a group name",
};
